export default __webpack_public_path__ + "static/media/027-blender.3ed2a1fd.svg";